<template>
  <div class="app-container">
    <el-form
      :model="queryParams"
      ref="queryForm"
      size="small"
      :inline="true"
      label-width="68px"
    >
      <el-form-item label="关键字" prop="key">
        <el-input
          v-model="queryParams.condition.key"
          placeholder="请输入关键字"
          clearable
          style="width: 240px"
        />
      </el-form-item>

      <el-form-item>
        <el-button
          type="primary"
          icon="el-icon-search"
          size="mini"
          @click="handleQuery"
          >搜索</el-button
        >
        <el-button icon="el-icon-refresh" size="mini" @click="resetQuery"
          >重置</el-button
        >
      </el-form-item>
    </el-form>

    <el-table
      v-loading="loading"
      :data="userList"
      :row-style="{ height: '58px' }"
      height="calc(100vh - 300px)"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
      border
    >
      <el-table-column
        label="任务编号"
        align="center"
        prop="taskNo"
        width="150"
        :show-overflow-tooltip="true"
      />
      <el-table-column
        label="项目名称"
        align="center"
        prop="projectName"
        :show-overflow-tooltip="true"
      />
      <el-table-column
        label="任务名称"
        align="center"
        prop="taskName"
        :show-overflow-tooltip="true"
      />
      <el-table-column
        label="工单需求描述"
        align="center"
        prop="taskDescription"
        :show-overflow-tooltip="true"
      >
      </el-table-column>

      <!-- <el-table-column
        label="工时/天"
        align="center"
        prop="taskWorkHours"
        width="100"
        :show-overflow-tooltip="true"
      /> -->
      <el-table-column
        label="工单状态"
        align="center"
        prop="taskStatus"
        width="120"
      >
        <template slot-scope="scope">
          <el-tag>{{ scope.row.taskStatus | StatusFiltering }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        label="是否发起过转单"
        align="center"
        prop="isStartTransfer"
        width="120"
      >
        <template slot-scope="scope">
          <el-tag :type="scope.row.isStartTransfer > 0 ? 'success' : 'info'">{{
            scope.row.isStartTransfer > 0 ? "是" : "否"
          }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        label="任务归属人"
        align="center"
        prop="personNames"
        width="160"
      >
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        width="220"
        class-name="small-padding fixed-width"
      >
        <template slot-scope="scope">
          <el-popconfirm
            title="确定认领工单吗？"
            icon="el-icon-info"
            icon-color="red"
            placement="top"
            @confirm="handleAccept(scope.row)"
          >
            <el-button
              size="mini"
              type="primary"
              icon="el-icon-edit"
              slot="reference"
              v-if="scope.row.personIds == UID"
              >任务认领</el-button
            >
          </el-popconfirm>
          <el-button
            size="mini"
            type="info"
            icon="el-icon-download"
            v-if="scope.row.orderFileUrl != ''"
            style="margin-left: 10px"
            @click="handleDownload(scope.row)"
            >工单附件</el-button
          >
          <el-button
            size="mini"
            type="success"
            icon="el-icon-s-promotion"
            style="margin-left: 10px"
            slot="reference"
            v-if="scope.row.personIds == UID"
            @click="handleTransfer(scope.row)"
            >转 单</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-dialog
      title="工单转单"
      :visible.sync="open"
      width="700px"
      append-to-body
      :destroy-on-close="true"
      :close-on-click-modal="false"
    >
      <el-form
        ref="form"
        :model="form"
        :rules="rules"
        label-width="80px"
        class="dialog-box"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item label="人员" label-width="90px" prop="receiverUserId">
              <el-select
                v-model="form.receiverUserId"
                style="margin-left: 20px"
                placeholder="请选择"
                clearable
              >
                <el-option
                  v-for="item in CeOptions"
                  :key="item.id"
                  :label="item.trueName"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item
              label="转单描述"
              prop="description"
              label-width="110px"
            >
              <el-input
                v-model="form.description"
                type="textarea"
                placeholder="请输入内容"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm" :loading="submitLoading"
          >确 定</el-button
        >
        <el-button @click="cancel">取 消</el-button>
      </div>
    </el-dialog>
    <pagination
      v-show="total > 0"
      :total="total"
      :page.sync="queryParams.page"
      :limit.sync="queryParams.limit"
      :pageSizes="[50, 100, 200, 500]"
      @pagination="getList"
    />
  </div>
</template>
  
  <script>
import {
  orderTaskPage,
  orderTaskPickUp,
  orderTaskTransfer,
} from "@/api/work/WorkTaskList";
import { getUserSelectByPage } from "@/api/plat/PlatStaff";
import { downloadFileByPost } from "@/utils/filenRequest.js";
export default {
  data() {
    return {
      userList: [],
      // 总条数
      total: 0,
      // 遮罩层
      loading: false,
      // 是否显示弹出层
      open: false,
      CeOptions: [],
      UID: "",
      form: {
        taskId: "",
        receiverUserId: "",
        description: "",
      },
      // 非多个禁用
      multiple: true,
      queryParams: {
        limit: 50,
        page: 1,
        condition: {
          orderStatus: "wait_pickup",
          key: "",
        },
        orderBy: "",
      },
      taskId: "", //任务id
      submitLoading: false, //提交按钮loading
      rules: {
        receiverUserId: [
          { required: true, message: "接收人不能为空", trigger: "change" },
        ],
        description: [
          {
            required: true,
            message: "工单需求描述不能为空",
            trigger: "change",
          },
        ],
      },
    };
  },
  created() {
    this.getList();
    this.UID = JSON.parse(sessionStorage.getItem("uid"));
  },
  methods: {
    /** 查询用户列表 */
    async getList() {
      this.loading = true;
      let { data } = await orderTaskPage(this.queryParams);
      this.userList = data.records;
      this.total = data.total;
      this.loading = false;
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.page = 1;
      this.getList();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.queryParams.condition.key = undefined;
      this.getList();
    },
    //员工认领
    async handleAccept(e) {
      let res = await orderTaskPickUp(e.taskId);
      if (res.code == 200) {
        this.$message({
          message: "认领成功",
          type: "success",
        });
      }
      this.getList();
    },
    //转单
    async handleTransfer(e) {
      this.open = true;
      let { data } = await getUserSelectByPage({
        condition: {
          departmentId: JSON.parse(sessionStorage.getItem("departmentId")),
        },
        limit: 9999,
        page: 1,
      });
      this.CeOptions = data.records;
      this.form.taskId = e.taskId;
    },
    // 取消按钮
    cancel() {
      this.open = false;
      this.form = {
        taskId: "",
        receiverUserId: "",
        description: "",
      };
    },

    //提交数据
    submitForm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.submitLoading = true;
          let res = await orderTaskTransfer(this.form);
          if (res.code == 200) {
            this.$message({
              message: "转单成功",
              type: "success",
            });
            this.open = false;
            this.getList();
          }
          this.submitLoading = false;
        }
      });
    },
    //附件下载
    async handleDownload(url) {
      downloadFileByPost(url.orderFileUrl);
    },
  },
};
</script>
  
  <style>
</style>